/**
 * 패널 플래닝 맵 — 줌(거리)에 따른 Array / String / Module 라벨 LOD
 *
 * ※ 지도 텍스트 라벨 전체 제거: formatPanelMap{A,S,M}Label() → null
 *    폴리곤 스타일(채움/테두리)만 유지. format null → createPanelMapFeatureLabelText 호출 안 됨.
 */

export const STRING_LABEL_MIN_ZOOM = 99;
export const STRING_LABEL_FULL_ZOOM = 99;
export const MODULE_LABEL_MIN_ZOOM = 99;
export const MODULE_LABEL_FULL_ZOOM = 99;

export const PANEL_MAP_LABEL_DEFAULTS = {
  stringMinZoom: STRING_LABEL_MIN_ZOOM,
  stringFullZoom: STRING_LABEL_FULL_ZOOM,
  moduleMinZoom: MODULE_LABEL_MIN_ZOOM,
  moduleFullZoom: MODULE_LABEL_FULL_ZOOM
};

const MODULE_LABEL_LIMIT_BY_ZOOM = [
  { minZoom: 99, maxFeatures: 0 },
];

export function getPanelMapModuleLabelLimitForZoom(zoom) {
  const z = Number(zoom);
  if (Number.isNaN(z)) return 0;
  for (const tier of MODULE_LABEL_LIMIT_BY_ZOOM) {
    if (z >= tier.minZoom) return tier.maxFeatures;
  }
  return 0;
}

export function getPanelMapLabelVisibility({
  zoom,
  moduleFeatureCount,
  stringMinZoom = PANEL_MAP_LABEL_DEFAULTS.stringMinZoom,
  stringFullZoom = PANEL_MAP_LABEL_DEFAULTS.stringFullZoom,
  moduleMinZoom = PANEL_MAP_LABEL_DEFAULTS.moduleMinZoom,
  moduleFullZoom = PANEL_MAP_LABEL_DEFAULTS.moduleFullZoom,
}) {
  const z = Number(zoom);
  if (!Number.isFinite(z)) return { stringFormat: null, moduleFormat: null, cacheKey: 'n_n' };

  let stringFormat = null;
  if (z >= stringMinZoom) stringFormat = z >= stringFullZoom ? 'full' : 'short';

  let moduleFormat = null;
  const count = Number(moduleFeatureCount);
  if (Number.isFinite(count) && z >= moduleMinZoom) {
    const limit = getPanelMapModuleLabelLimitForZoom(z);
    if (count <= limit) moduleFormat = z >= moduleFullZoom ? 'full' : 'short';
  }

  return { stringFormat, moduleFormat, cacheKey: `${stringFormat || 'n'}_${moduleFormat || 'n'}` };
}

/** 지도 텍스트 라벨 제거됨 */
export function formatPanelMapStringLabel() { return null; }

/** 지도 텍스트 라벨 제거됨 */
export function formatPanelMapModuleLabel() { return null; }

/** 지도 텍스트 라벨 제거됨 */
export function formatPanelMapArrayLabel() { return null; }
